import { cva, type VariantProps } from "class-variance-authority"
import Link from "next/link"

import { twMerge } from "tailwind-merge"

const button = cva(
  [
    "justify-center",
    "inline-flex",
    "text-white",
    "items-center",
    "rounded-lg",
    "text-center",
    "transition-colors",
    "delay-50",
  ],
  {
    variants: {
      intent: {
        primary: ["bg-inherit hover:bg-black/90 text-black dark:text-white hover:text-white focus:outline-none border-2 border-solid border-black dark:border-white hover:border-white dark:hover:bg-gray-500 dark:border-gray-500"],
        secondary: ["bg-gray-900 hover:bg-gray-500"], 
      },
      size: {
        sm: ["min-w-20", "h-full", "min-h-10", "text-sm", "py-1.5", "px-4"],
        lg: ["min-w-32", "h-full", "min-h-12 max-h-12", "text-lg", "py-2.5", "px-6"],
      },
      underline: { true: ["underline"], false: [] },
    },
    defaultVariants: {
      intent: "primary",
      size: "lg",
    },
  }
)

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLAnchorElement>, VariantProps<typeof button> {
  underline?: boolean
  href: string
  className?: string
}

export function ButtonLink({ className, intent, size, underline, ...props }: ButtonProps) {
  return (
    <Link className={twMerge(button({ intent, size, className, underline }))} {...props}>
      {props.children}
    </Link>
  )
}
